import {
  SIDEBAR_TYPE,
  TOGGLE_MOBILE_TYPE,
  TOGGLE_NAV_THEME,
  TOGGLE_LAYOUT,
  TOGGLE_FIXED_HEADER,
  TOGGLE_FIXED_SIDEBAR,
  TOGGLE_CONTENT_WIDTH,
  TOGGLE_HIDE_HEADER,
  TOGGLE_COLOR,
  TOGGLE_WEAK,
  TOGGLE_MULTI_TAB,
  // i18n
  APP_LANGUAGE,
  GLOBAL_CONFIG,
  SET_DISK_SERIALS,
  LOGIN_LOCATION,
  BIND_DEVICE,
  TOGGLE_SIDEBAR,
  TOGGLE_DEVICE
} from '@/store/mutation-types'
import { getGlobalConfig } from '@/apis/config'

const app = {
  state: {
    sideCollapsed: false,
    isMobile: false,
    theme: 'dark',
    layout: '',
    contentWidth: '',
    fixedHeader: false,
    fixedSidebar: false,
    autoHideHeader: false,
    color: '',
    weak: false,
    multiTab: true,
    lang: 'en-US',
    _antLocale: {},
    globalConfig: {},
    diskSerials: '',
    location: {},
    bindDevice: {},
    sidebar: {
      opened: true,
      withoutAnimation: false
    },
    device: 'desktop',
    sidebarLogo: true
  },
  mutations: {
    [SIDEBAR_TYPE]: (state, type) => {
      state.sideCollapsed = type
      localStorage.setItem(SIDEBAR_TYPE, type)
    },
    [TOGGLE_MOBILE_TYPE]: (state, isMobile) => {
      state.isMobile = isMobile
    },
    [TOGGLE_NAV_THEME]: (state, theme) => {
      state.theme = theme
      localStorage.setItem(TOGGLE_NAV_THEME, theme)
    },
    [TOGGLE_LAYOUT]: (state, mode) => {
      state.layout = mode
      localStorage.setItem(TOGGLE_LAYOUT, mode)
    },
    [TOGGLE_FIXED_HEADER]: (state, mode) => {
      state.fixedHeader = mode
      localStorage.setItem(TOGGLE_FIXED_HEADER, mode)
    },
    [TOGGLE_FIXED_SIDEBAR]: (state, mode) => {
      state.fixedSidebar = mode
      localStorage.setItem(TOGGLE_FIXED_SIDEBAR, mode)
    },
    [TOGGLE_CONTENT_WIDTH]: (state, type) => {
      state.contentWidth = type
      localStorage.setItem(TOGGLE_CONTENT_WIDTH, type)
    },
    [TOGGLE_HIDE_HEADER]: (state, type) => {
      state.autoHideHeader = type
      localStorage.setItem(TOGGLE_HIDE_HEADER, type)
    },
    [TOGGLE_COLOR]: (state, color) => {
      state.color = color
      localStorage.setItem(TOGGLE_COLOR, color)
    },
    [TOGGLE_WEAK]: (state, mode) => {
      state.weak = mode
      localStorage.setItem(TOGGLE_WEAK, mode)
    },
    [APP_LANGUAGE]: (state, lang, antd = {}) => {
      state.lang = lang
      state._antLocale = antd
      localStorage.setItem(APP_LANGUAGE, lang)
    },
    [TOGGLE_MULTI_TAB]: (state, bool) => {
      localStorage.setItem(TOGGLE_MULTI_TAB, bool)
      state.multiTab = bool
    },
    [GLOBAL_CONFIG]: (state, config) => {
      state.globalConfig = config
      localStorage.setItem(GLOBAL_CONFIG, JSON.stringify(config))
    },
    [SET_DISK_SERIALS]: (state, diskSerials) => {
      state.diskSerials = diskSerials
    },
    [LOGIN_LOCATION]: (state, location) => {
      state.location = location
    },
    [BIND_DEVICE]: (state, bindDevice) => {
      state.bindDevice = bindDevice
    },
    [TOGGLE_SIDEBAR]: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    [TOGGLE_DEVICE]: (state, device) => {
      state.device = device
    }
  },
  actions: {
    setLang ({ commit }, lang) {
      return new Promise((resolve, reject) => {
        commit(APP_LANGUAGE, lang)
      })
    },
    setConfig({ commit }) {
      console.log('NODE_ENV', process.env.NODE_ENV)
      return new Promise((resolve, reject) => {
        getGlobalConfig().then(res => {
          const data = res
          if (process.env.NODE_ENV === 'development') {
            data.brandCode = process.env.VUE_APP_BRAND_CODE
            data.appUrl = process.env.VUE_APP_BASE_API_BUSINESS
            // data.appUrl = 'http://192.168.0.110:18008'
            data.qrCode = process.env.VUE_APP_QR_CODE_PRE
          }
          commit(GLOBAL_CONFIG, data)
          resolve()
        }).catch(err => {
          console.error(err)
          reject()
        })
      })

    },
    setDiskSerials({ commit }, code) {
      commit(SET_DISK_SERIALS, code)
    },
    setLocation({ commit }, location) {
      commit(LOGIN_LOCATION, location)
      localStorage.setItem(LOGIN_LOCATION, JSON.stringify(location))
    },
    updateBindDevice({ commit }, bindDevice) {
      commit(BIND_DEVICE, bindDevice)
    },
    toggleSideBar({ commit }) {
      commit(TOGGLE_SIDEBAR)
    },
    toggleDevice({ commit }, device) {
      commit(TOGGLE_DEVICE, device)
    }
  }
}

export default app
